<div style="width: 478px; height: 534px; background: white; border-radius: 20px">

    <img class="preview-pop-up" [src]="previewEntry?.submission[previewImageIndex]?.url" />
    <div class="pagination" *ngIf="previewEntry?.submission && previewEntry?.submission.length>1">
        <div
            style="width: 9%; height: 23px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: inline-flex; cursor: pointer;" (click)="previewImagePagination(-1)">
            <img *ngIf="previewImageIndex > 0" src="assets/left-angle.svg" >
            <img *ngIf="previewImageIndex <= 0" src="assets/disable-left-open.svg" >
        </div>
        <div
            style="width: 9%; height: 100%; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: inline-flex; margin-left: 7px;margin-right: 7px;">
            <div
                style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                {{previewImageIndex +1}}</div>
        </div>
        <div
            style="width: 9%; height: 23px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: inline-flex; cursor: pointer;" (click)="previewImagePagination(1)">
            <img *ngIf="previewImageIndex <  previewEntry?.submission.length-1" src="assets/right-open.svg">
            <img *ngIf="previewImageIndex >=  previewEntry?.submission.length-1" src="assets/disable-right-open.svg">
        </div>

    </div>
</div>